// Typelizer digest 5d39055145460235be05590db60e9a55
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /educators/teachers/:teacher_id/classes/:class_id/transfers */
  index: (
    params: { teacherId: string | number; classId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/classes/:class_id/transfers', params, options),
    method: 'get',
  }),

  /** PATCH /educators/teachers/:teacher_id/classes/:class_id/transfers/:id */
  update: (
    params: { teacherId: string | number; classId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/classes/:class_id/transfers/:id', params, options),
    method: 'patch',
  }),
}
